import './Header.css';
import {Link} from "react-router";

export default function Header() {
    return (<header className="header">
        <Link to="/">Search Recipes</Link>
    </header>);
}